
//html側で設定する
//var doy;
//var files2018;
//var files2019;
//var files2020;
//var files2021;
//var files2022;
//var files2023;
//var fileNamePrefix = "Tokyo_D_chla_tgt_week";


var f00 = function(x){
	return new String(x + 100).substr(1,2);
};

var f0000 = function(x){
	return new String(x + 10000).substr(1,4);
};

var formatDate = function(t){
	var y = t.getFullYear();
	var m = t.getMonth() + 1;
	var d = t.getDate();
	var h = t.getHours();
	var n = t.getMinutes();

	return f0000(y) + "/" + f00(m) + "/" + f00(d);// + " " + f00(h) + ":" + f00(n);
};

var formatDate2 = function(t){
	var y = t.getFullYear();
	var m = t.getMonth() + 1;
	var d = t.getDate();
	var h = t.getHours();
	var n = t.getMinutes();

	//return f0000(y) + "-" + f00(m) + "-" + f00(d) + " " + f00(h) + ":" + f00(n);
	return f00(m) + "/" + f00(d);// + " " + f00(h) + ":" + f00(n);
};


var Images = function(files,year){

	var list = [];
	var idx = fileNamePrefix.length;

	for(var f of files){

		const img = new Image();
		img.src = "./files/" + f;

		list.push({
			date: new Date(parseInt(f.substr(idx,4)),parseInt(f.substr(idx+4,2))-1,parseInt(f.substr(idx+6,2))),
			img: img,
		})
	}

	this.get = function(doy){
		var date = new Date(year,0,doy);

		if(date.getTime() < new Date(list[0].date).getTime()){

			const img = new Image();
			img.src = "./img/null.png";

			return {
				date: new Date(year,0,1),
				img: img,
			}
		}

		if(new Date(list[list.length - 1].date).getTime() <= date.getTime()){
			return list[list.length - 1];
		}

		var ii = 0;

		for(var i=0;i<list.length-1;i++){
			if(new Date(list[i].date).getTime() <= date.getTime() && date.getTime() < new Date(list[i+1].date).getTime()){
				ii = i;
				break;
			}
		};

		return list[ii];
	};
};

var imgs2018 = new Images(files2018,2018);
var imgs2019 = new Images(files2019,2019);
var imgs2020 = new Images(files2020,2020);
var imgs2021 = new Images(files2021,2021);
var imgs2022 = new Images(files2022,2022);
var imgs2023 = new Images(files2023,2023);
var imgs2024 = new Images(files2024,2024);

var rg = document.getElementById("rg");
rg.min = 1;
rg.max = doy;

const changed = function(e){

	var doy = parseInt(rg.value);

	document.getElementById("date").innerHTML = formatDate2(new Date(2022,0,doy));

	var i2018 = imgs2018.get(doy);
	document.getElementById("date2018").innerHTML = formatDate(i2018.date);
	document.getElementById("img2018").src = i2018.img.src;

	var i2019 = imgs2019.get(doy);
	document.getElementById("date2019").innerHTML = formatDate(i2019.date);
	document.getElementById("img2019").src = i2019.img.src;

	var i2020 = imgs2020.get(doy);
	document.getElementById("date2020").innerHTML = formatDate(i2020.date);
	document.getElementById("img2020").src = i2020.img.src;

	var i2021 = imgs2021.get(doy);
	document.getElementById("date2021").innerHTML = formatDate(i2021.date);
	document.getElementById("img2021").src = i2021.img.src;

	var i2022 = imgs2022.get(doy);
	document.getElementById("date2022").innerHTML = formatDate(i2022.date);
	document.getElementById("img2022").src = i2022.img.src;

	var i2023 = imgs2023.get(doy);
	document.getElementById("date2023").innerHTML = formatDate(i2023.date);
	document.getElementById("img2023").src = i2023.img.src;

	var i2024 = imgs2024.get(doy);
	document.getElementById("date2024").innerHTML = formatDate(i2024.date);
	document.getElementById("img2024").src = i2024.img.src;
};

//Chrome用
rg.addEventListener("input",changed);

//IE用
rg.addEventListener("change",changed);

rg.value = Math.floor(rg.max * 0.5);
rg.dispatchEvent(new Event("input"));
